import { eventCategory } from "@foretagsplatsen/yaem";
import { object } from "klassified";

/**
 * Holds the selected report item in the report editor.
 *
 * Each time the selection changes, an event `selectionChanged` is triggered
 * with the new selection.
 */
export default object.singletonSubclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);
		my.selection = null;
	};

	my.events = eventCategory();
	that.selectionChanged = my.events.createEvent();

	that.hasSelection = function () {
		return !!my.selection;
	};

	that.canAdd = function (item) {
		return my.selection && my.selection.canAdd(item);
	};

	that.get = function () {
		return my.selection;
	};

	that.set = function (newSelection) {
		my.selection = newSelection;
		that.selectionChanged.trigger(my.selection);
	};

	that.toggle = function (selection) {
		if (my.selection === selection) {
			that.set(null);
		} else {
			that.set(selection);
		}
	};

	that.clear = function () {
		that.set(null);
	};

	that.isSelected = function (item) {
		return my.selection === item || my.selection === item.getTemplate();
	};
});
